module.exports = __webpack_public_path__ + "img/chest.2b6e532f.png";